import type {
  CoreNodeConstraints,
  CoreNodeSorts
} from '@aurora/shared-generated/types/graphql-schema-types';
import { SortDirection } from '@aurora/shared-generated/types/graphql-schema-types';
import type {
  NodeViewsQuery,
  NodeViewsQueryVariables
} from '@aurora/shared-generated/types/graphql-types';
import nodeViewsQuery from '../../nodes/NodeViews.query.graphql';
import useQueryWithTracing from '../../useQueryWithTracing';
import PaginationHelper from '../../../helpers/ui/PaginationHelper/PaginationHelper';
import type { QueryResultWithPaginationHelper } from '../../../helpers/ui/PaginationHelper/types';

const sorts: CoreNodeSorts = {
  communityStructure: { direction: SortDirection.Asc, order: 0 },
  position: { direction: SortDirection.Asc, order: 1 }
};

/** Performs a query for nodes based on supplied constraints & returns both the initial result and a pagination helper for loading more. */
export default function useNodeSelectorDropdownNodeViews(
  constraints: CoreNodeConstraints,
  skip: boolean
): QueryResultWithPaginationHelper<NodeViewsQuery, NodeViewsQueryVariables> {
  const pageSize = 15;

  const variables = {
    constraints,
    sorts,
    useNodeAvatar: false,
    useNodeParent: true,
    useChildNodes: true,
    useFullPageInfo: true,
    first: pageSize
  };

  const queryResult = useQueryWithTracing<NodeViewsQuery, NodeViewsQueryVariables>(
    module,
    nodeViewsQuery,
    {
      variables,
      skip
    }
  );

  const { fetchMore, data } = queryResult;

  const pageInfo = data?.coreNodes?.pageInfo;

  const paginationHelper = new PaginationHelper<NodeViewsQuery, NodeViewsQueryVariables>(
    fetchMore,
    pageInfo,
    'coreNodes',
    pageSize,
    { ...variables, after: pageInfo?.endCursor },
    connection => {
      return { coreNodes: connection } as unknown as NodeViewsQuery;
    }
  );

  return { queryResult, paginationHelper };
}
